$(document).ready(() => {

    //Ouverture et Fermeture afiner-recherche--wrapper mobile
    $('#sidebar-filters-btn').on('click', () => {
        $('.affiner-recherche--wrapper').toggleClass('is--open');
    });
    $('#close-affiner-recherche').on('click', () => {
        $('.affiner-recherche--wrapper').toggleClass('is--open');
    });


    //changement de product-maincat__entete__p en fonction de affiner recherche et modèles

        //Partie modèle [catégorie] DOM original
        if($('.subcat_list').length == 1){
            $('.product-maincat__entete__affiner__h2--modeles').toggleClass('is--visible');
            $('#sidebar-filters-btn').html("Découvrez nos modèles");
            let nbrProducts = $('#list-catprods-prod').children().length;
            infosCat(nbrProducts);
        }

        //Partie filtre [sous-catégorie] DOM original
        if($('.filter_list').length == 1){
            $('.product-maincat__entete__affiner__h2--recherche').toggleClass('is--visible');
            let nbrProducts = $('#cat-list2').children().length;
            infosCat(nbrProducts);

            //Dès que l'utilisateur clic sur un input on compte combien de produit sont affichés et on affiche se nombre [sous-catégorie] DOM modifié
            $('body').on('change', 'input', function() {
                var nbrProducts2 = 0;
                for(let i=0; i <= nbrProducts-1;i++){ 
                    if($('#cat-list2').find('article')[i].style.display == "block"){
                        nbrProducts2 = nbrProducts2+1;
                    }
                }
                infosCat(nbrProducts2);
            });
        }

});


//fonction qui selon le nombre de produits données affiche la bonne syntaxe pour [product-maincat__entete__p]
function infosCat(nbrProducts){
    $('#nbr-products').html(nbrProducts+" ");
    if(nbrProducts <= 1){
        $('#single-product').css('display','inline-block');
        $('#plural-products').css('display','none');
    }
    else{
        $('#plural-products').css('display','inline-block');
        $('#single-product').css('display','none');
    }
}